import owd from 'owd/owd';

export default class HeroInit extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('domready ajaxload', this.dom.$window, () => {
            this.heading = this.$element.find('.home-hero-init-heading');
            this.heading.each((i, obj) => {
                var words = $(obj).text().split(" ");
                $(obj).empty();
                words.forEach(elem => {
                    $(obj).append($('<span>').text(elem));
                });
            });
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('hero-init', {
	component: HeroInit
});
